/**
 * CellMapPopover - Popover flotante en el mapa al hacer clic en una celda
 *
 * @version 1.0
 * @updated 2026-02-25
 * @module core/layouts/panels/RightPanel
 *
 * @description
 * Popover que aparece sobre una celda en el mapa cuando se hace clic.
 * Muestra un círculo con ícono de estadísticas y permite abrir el panel de detalles.
 *
 * @remarks
 * Se posiciona absolutamente sobre el mapa usando coordenadas del viewport.
 */

import { BarChart3 } from 'lucide-react';
import './cell-map-popover.css';

/**
 * Props del componente
 */
export interface CellMapPopoverProps {
  /**
   * Coordenadas del viewport donde posicionar el popover (px)
   */
  position: { x: number; y: number };

  /**
   * Callback al hacer clic en el popover
   */
  onClick: () => void;

  /**
   * Callback al cerrar el popover
   */
  onClose: () => void;
}

/**
 * Popover flotante en el mapa
 */
export function CellMapPopover({ position, onClick, onClose }: CellMapPopoverProps): JSX.Element {
  return (
    <div
      className="cell-map-popover"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
      onMouseLeave={onClose}
    >
      <button
        className="cell-map-popover-btn"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        title="Ver detalles de la celda"
        aria-label="Ver estadísticas"
      >
        <BarChart3 size={20} />
      </button>
    </div>
  );
}
